import { render, staticRenderFns } from "./permissionList.vue?vue&type=template&id=2ac4eaa4&scoped=true&"
import script from "./permissionList.vue?vue&type=script&lang=js&"
export * from "./permissionList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac4eaa4",
  null
  
)

export default component.exports